import * as React from 'react';
// @ts-ignore
import { DataItem } from './types/DataItem';
import Accordion from '../../../core/components/Accordion/Accordion';
import styles from './GeneralDataProtection.module.scss';
import ApiProvider from '../../../core/api/ApiProvider';
import Status from '../../../core/types/Status';
import { Alert, Button, Label, Loader, ModuleContainer } from '../../../core/components';
import { TranslationService } from '../../../core/services';

const GeneralDataProtection = () => {
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [model, setModel] = React.useState<DataItem[]>([]);

  const fetchGeneralData = async () => {
    try {
      setIsLoading(true);
      const data = await ApiProvider.post<Status<DataItem[]>>(
        'GeneralDataProtectionModule/GetCurrentUserGeneralData'
      );
      setModel(data.data);
    } finally {
      setIsLoading(false);
    }
  };

  const fillList = (value: string | DataItem[], leveldepth: number) => {
    if (Array.isArray(value)) {
      return (
        <ul>
          {value.map((item, index) => {
            var val = item.value.value;
            if (typeof val === 'string') {
              return (
                <li className={styles.listItem} key={`${leveldepth}_${index}`}>
                  <span className={styles['data-label']}>{item.name}:</span>
                  {val}
                </li>
              );
            } else {
              return (
                <li key={`${leveldepth}_${index}`}>
                  <Accordion currentOpen={0} onToggle={() => {}}>
                    <Accordion.Item key={`${leveldepth}_${index}`} className={styles.listWrapper}>
                      <Accordion.Header index={index}>{item.name}</Accordion.Header>
                      <Accordion.Body index={index} className={styles.accordionBody}>
                        {fillList(val, leveldepth + 1)}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </li>
              );
            }
          })}
        </ul>
      );
    } else {
      return '';
    }
  };

  const onClick = () => {
    ApiProvider.downloadFile('GeneralDataProtectionModule/GetJsonFileData');
  };

  const handleOnPrintClick = () => {
    window.print();
  };

  React.useEffect(() => {
    fetchGeneralData();
  }, []);

  return (
    <ModuleContainer classNames="mt-2">
      <ModuleContainer.Header title={TranslationService.translate('GeneralDataProtection')} />
      <ModuleContainer.Body variant={ModuleContainer.Body.BodyVariant.Primary}>
        {isLoading && <Loader opacity={0.4} />}
        {!isLoading && (
          <Alert variant={Alert.Variants.Info} icon={true} className="mb-2">
            <>
              {TranslationService.translate('ExportDataInfo1')}
              <a
                href={TranslationService.translate('PersonalLinkValue')}
                rel="noreferrer"
                target="_blank"
                id="communication-acceptance-link"
              >
                {TranslationService.translate('PersonalInfoLink')}
              </a>
              {TranslationService.translate('CommunicationAcceptanceInfo2')}
            </>
          </Alert>
        )}
        <div className="row">
          <div className="col-auto">
            <Button
              variant={Button.Variants.Primary}
              classNames="mr-1"
              onClick={handleOnPrintClick}
            >
              {TranslationService.translate('PrintPage')}
            </Button>
          </div>

          <div className="col-auto ml-3">
            <Button variant={Button.Variants.Primary} onClick={onClick}>
              {TranslationService.translate('ExportUserData')}
            </Button>
            <Label className={styles.exportDataLabel}>
              {`*${TranslationService.translate('ExportDebtCollectionInfo')}`}
            </Label>
          </div>
        </div>

        <Accordion currentOpen={0} onToggle={() => {}} className="mt-1 printable">
          {model.map((section: DataItem, index: number) => {
            return (
              <Accordion.Item key={`root_${index.toString()}`}>
                <Accordion.Header index={index}>{section.name}</Accordion.Header>
                <Accordion.Body index={index} className={styles.accordionBody}>
                  {fillList(section.value.value, 1)}
                </Accordion.Body>
              </Accordion.Item>
            );
          })}
        </Accordion>
      </ModuleContainer.Body>
    </ModuleContainer>
  );
};
export default GeneralDataProtection;
